"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
export default function TanstackProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  // Zajistí, že každý uživatel dostane vlastní instanci QueryClientu
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}
